import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onSubmit,
}: ConfirmationModalProps) => (
  <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onClose}>
    <DialogTitle>Confirm to publish ETI?</DialogTitle>
    <IconButton aria-label="close" onClick={onClose} sx={closeIconStyle}>
      <CloseIcon />
    </IconButton>
    <DialogActions>
      <Button color="primary" onClick={onClose}>
        No
      </Button>
      <Button color="error" onClick={onSubmit}>
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);

const closeIconStyle = (theme: Theme) => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: theme.palette.grey[500],
});

export default ConfirmationModal;
